<template>
  <div v-show="show">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon id="status-icon" v-on="on" :color="getStatusColor()">{{ getStatusIcon() }}</v-icon>
      </template>
      <span id="status-tooltip" >{{ textToolTip }}</span>
    </v-tooltip>
  </div>
</template>

<script>

export default {
  name: 'StatusIcon',
  props: {
    textToolTip: {type: String, default: ''},
    status: {type: String },
    show: {type: Boolean }
  },
  methods: {
    getStatusIcon() {
      switch (this.status) {
        case 'available':
          return 'task_alt'
        case 'unavailable':
          return 'unpublished'
        case 'unknown':
        default:
          return 'question_mark'
      }
    },
    getStatusColor() {
      switch (this.status) {
        case 'available':
          return 'green darken-2'
        case 'unavailable':
          return 'red darken-2'
        case 'unknown':
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>

</style>
